import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { EnhancedTableColumn } from '../../types';

interface DraggableColumnHeaderProps<T> {
  column: EnhancedTableColumn<T>;
  children: React.ReactElement;
  disabled?: boolean;
}

export function DraggableColumnHeader<T>({
  column,
  children,
  disabled = false,
}: DraggableColumnHeaderProps<T>) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: String(column.id),
    disabled,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  // Clone the child element (TableCell) and add drag functionality
  const childProps = (children as React.ReactElement<Record<string, unknown>>)
    .props;
  return React.cloneElement(
    children as React.ReactElement<Record<string, unknown>>,
    {
      ref: setNodeRef as React.Ref<unknown>,
      style: {
        ...style,
        ...((childProps['style'] as React.CSSProperties) || {}),
      },
      sx: {
        cursor: disabled ? 'default' : 'grab',
        '&:active': {
          cursor: disabled ? 'default' : 'grabbing',
        },
        userSelect: 'none',
        ...(childProps['sx'] as Record<string, unknown>),
      },
      ...attributes,
      ...listeners,
    },
  );
}
